import React from "react";
import { Spinner } from "react-rainbow-components";
import ChatContent from "../../components/chatComponent/ChatContent";
import { CardSummary } from "../../components/databaseAdminComponent/CardSummary";
import { ChatContainer } from "./index.style";
import useChatPage from "./useChatPage";
export default function ChatPage() {
  const {
    setIsLoading,
    dataCard,
    isLoading,
    handleChangeTage,
    width,
    handleSubmit,
  } = useChatPage();

  return (
    <ChatContainer
      direction="row"
      style={{ overflow: width > 767 ? "hidden" : undefined }}
    >
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <ChatContent {...dataCard} />
          {width > 767 && (
            <CardSummary
              style={{
                marginLeft: 0,
                margin: width > 767 ? " 2rem 0 2rem 0" : undefined,
              }}
              setIsLoading={setIsLoading}
              isLoading={isLoading}
              booking={dataCard}
              handleSubmit={handleSubmit}
              handleChangeTage={handleChangeTage}
            />
          )}
        </>
      )}
    </ChatContainer>
  );
}
